import type { CommunityList, Profile } from 'models';
import { canManageCommunityProfile } from './can-manage-community';
import { hasMembershipInMultipleCommunitiesProfile } from './user-roles';

export const canLeaveCommunityProfile = ({ community, viewer }: { community: CommunityList; viewer: Profile }) =>
  hasMembershipInMultipleCommunitiesProfile({ viewer }) &&
  (Boolean(community.settings.allowUnsubscribe) || canManageCommunityProfile({ community, viewer }));
